import { cloneDeep } from 'lodash';

import generateClientUuid from 'sharedParts/utils/generateClientUuid';
import blockConfig from 'sharedParts/config/blockConfig';

const cloneBlockDefaultConfig = blockType =>
  blockConfig[blockType]
    ? cloneDeep(blockConfig[blockType].getDefaultProps())
    : {};

const createRawBlock = blockType => ({
  ...cloneBlockDefaultConfig(blockType),
  clientUuid: generateClientUuid(),
  type: blockType,
});

export default createRawBlock;
